import React from "react";



import styled from "styled-components/macro";



import { useSignups } from "Signups/state.js";
import { useIsSuggestedDonation } from "Signups/stateHooks";
import { motion } from "framer-motion";



import FnrButton3 from "UI/FnrButton3";



import { getAmountInDollarsClean } from "Utilities/Amount/getAmountInDollarsClean";
import { useWindowSize } from "Utilities/Hooks/useWindowSize";
import { formatNumberWithCommas } from "Utilities/Number/formatNumberWithCommas";
import capitalize from "Utilities/capitalize";



import { Container } from "../Styles";



import useIsPayNowSticky from "./useIsPayNowSticky";


const FOOTER_BREAKPOINT = 1190;

export default function PayNowArea({
  handleClick,
  amount,
  unpaidSlots,
  entity,
  entityPlural,
  footerRef,
}) {
  const [state] = useSignups();
  const isSuggestedDonation = useIsSuggestedDonation();
  const windowSize = useWindowSize();
  const minAmount = 2 * 100; // $2 (in cents)
  const maxAmount = 10000 * 100; // $10,000 (in cents)

  const amountIsWithinBounds =
    Number(amount) >= minAmount && Number(amount) <= maxAmount;
  const amountToDisplay = getAmountInDollarsClean(amount);

  const networkName = state.network?.name || "your organization";

  const { isSticky, ref: wrapperRef } = useIsPayNowSticky(amount);

  const getOutOfBoundsMsg = () => {
    if (amountIsWithinBounds) return null;
    else if (amount < minAmount) {
      return (
        <div>
          <span className="far fa-exclamation-triangle" />
          {isSuggestedDonation ? "Donations" : "Payments"} must be for at least
          $2. {!isSuggestedDonation ? "Please select additional items." : null}
        </div>
      );
    } else if (amount > maxAmount) {
      return (
        <div>
          <span className="far fa-exclamation-triangle" /> The maximum amount
          per transaction is $10,000. Please update your selected options and
          complete your signup in two transactions if necessary.
        </div>
      );
    }
  };

  const disclaimer = () => (
    <Disclaimer>
      For all payment & refund questions, please refer to the admins of{" "}
      {networkName}.
    </Disclaimer>
  );

  const getButtonSize = () => {
    if (windowSize.width < 580) return "medium";
    else return "large";
  };

  const contentProps = {
    unpaidSlots,
    entity,
    entityPlural,
    disclaimer,
    handleClick,
    getButtonSize,
    amountIsWithinBounds,
    amountToDisplay,
    getOutOfBoundsMsg,
  };

  const sidebarAnimations = {
    initial: { opacity: 0, x: 150 },
    animate: {
      opacity: 1,
      x: 0,
      transition: {
        type: "spring",
        bounce: 0.45,
        duration: 0.3,
      },
    },
    exit: { opacity: 0, x: 150, transition: { duration: 0.3 } },
  };

  const footerAnimations = {
    initial: { opacity: 0, bottom: -150 },
    animate: {
      opacity: 1,
      bottom: -50,
      transition: {
        type: "spring",
      },
    },
    exit: { opacity: 0, bottom: -150 },
  };

  const renderInnerContent = ({ isFooter }) => {
    return (
      <SContainer>
        {isSuggestedDonation ? (
          <DonationContent isFooter={isFooter} {...contentProps} />
        ) : (
          <PaymentContent isFooter={isFooter} {...contentProps} />
        )}
      </SContainer>
    );
  };

  // if (windowSize.width > FOOTER_BREAKPOINT) {
  //   return (
  //     <OuterWrapper>
  //       <Wrapper ref={wrapperRef} $isSticky={isSticky} {...sidebarAnimations}>
  //         {renderInnerContent({ isFooter: false })}
  //       </Wrapper>
  //     </OuterWrapper>
  //   );
  // }

  return (
    <OuterWrapperFooter>
      <WrapperFooter ref={footerRef} {...footerAnimations}>
        {renderInnerContent({ isFooter: true })}
      </WrapperFooter>
    </OuterWrapperFooter>
  );
}

function PaymentContent({
  isFooter,
  unpaidSlots,
  entity,
  entityPlural,
  disclaimer,
  handleClick,
  getButtonSize,
  amountIsWithinBounds,
  amountToDisplay,
  getOutOfBoundsMsg,
}) {
  return (
    <Content isFooter={isFooter}>
      <Left>
        <Lead>Your signup includes</Lead>
        <Title>
          {unpaidSlots} Unpaid{" "}
          {capitalize(unpaidSlots === 1 ? entity : entityPlural)}
        </Title>

        {isFooter && disclaimer()}
      </Left>
      <Right isFooter={isFooter}>
        <FnrButton3
          color="green"
          onClick={handleClick}
          size={getButtonSize()}
          disabled={!amountIsWithinBounds}
          fullWidth
        >
          Pay ${formatNumberWithCommas(amountToDisplay)} Now
        </FnrButton3>

        {!isFooter && disclaimer()}

        <OutOfBoundsMsg>{getOutOfBoundsMsg()}</OutOfBoundsMsg>
      </Right>
    </Content>
  );
}

function DonationContent({
  isFooter,
  disclaimer,
  handleClick,
  getButtonSize,
  amountIsWithinBounds,
  amountToDisplay,
  getOutOfBoundsMsg,
}) {
  return (
    <Content isFooter={isFooter}>
      <Left>
        {isFooter ? (
          <Title>${amountToDisplay} Suggested Donation</Title>
        ) : (
          <Title>
            <div style={{ fontSize: "42px", fontWeight: "600" }}>
              ${amountToDisplay}
            </div>
            <div style={{ fontSize: "17px", opacity: "0.8", fontWeight: 400 }}>
              Suggested Donation
            </div>
          </Title>
        )}

        {isFooter && disclaimer()}
      </Left>
      <Right isFooter={isFooter}>
        <FnrButton3
          color="green"
          onClick={handleClick}
          size={getButtonSize()}
          disabled={!amountIsWithinBounds}
          fullWidth
        >
          Donate Now
        </FnrButton3>

        {!isFooter && disclaimer()}

        <OutOfBoundsMsg>{getOutOfBoundsMsg()}</OutOfBoundsMsg>
      </Right>
    </Content>
  );
}

const SContainer = styled(Container)`
  max-width: 600px;
  padding: 0 44px;
`;

const OuterWrapper = styled.div``;

const OuterWrapperFooter = styled.div``;

const WrapperBase = styled(motion.div)`
  color: #333;
  padding-bottom: 40px;
  z-index: 30;
`;

const Wrapper = styled(WrapperBase)`
  position: ${(p) => (p.$isSticky ? "fixed" : "absolute")};
  top: ${(p) => (p.$isSticky ? 0 : "auto")};
  background: white;
  max-width: 260px;
  margin-top: 30px;
  margin-left: 10px;
  border-radius: 8px;
  box-shadow: 2px 2px 8px rgb(0 0 0 / 5%);
`;

const WrapperFooter = styled(WrapperBase)`
  background-image: linear-gradient(197deg, #f7e6ba, #ffefca);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding-bottom: 50px;
  box-shadow: -1px 0 8px hsl(0 0% 0% / 0.6);
`;

const Content = styled.div`
  display: flex;
  flex-direction: ${({ isFooter }) => (isFooter ? "row" : "column")};
  padding-block: 20px;
  gap: 20px;

  @media (max-width: 580px) {
    flex-direction: column;
    padding-block: 10px;
  }
`;

const Left = styled.div``;

const Right = styled.div`
  min-width: ${({ isFooter }) => (isFooter ? "250px" : "100%")};
  flex: 1;
  flex-shrink: 0;
  align-self: center;

  @media (min-width: 768px) {
    align-self: center;
  }
`;

const Lead = styled.div`
  font-size: 14px;
  font-weight: 400;
  opacity: 0.8;

  @media (max-width: ${FOOTER_BREAKPOINT}px) {
    font-size: 12px;
  }

  @media (max-width: 580px) {
    display: none;
  }
`;

const Title = styled.div`
  font-weight: 600;
  font-size: 24px;

  @media (max-width: ${FOOTER_BREAKPOINT}px) {
    margin-top: 4px;
    font-size: 21px;
  }

  @media (max-width: 580px) {
    font-size: 18px;
    text-align: center;
  }
`;

const Disclaimer = styled.div`
  margin-top: 15px;
  font-size: 11px;
  font-weight: 400;
  opacity: 0.8;

  @media (max-width: ${FOOTER_BREAKPOINT}px) {
    margin-top: 10px;
  }

  @media (max-width: 580px) {
    font-size: 11px;
    text-align: center;
  }
`;

const OutOfBoundsMsg = styled.div`
  font-weight: 400;
  font-size: 12px;
  margin-top: 5px;
  /* text-align: center; */
`;